import React, { useState } from "react";
import styled from "styled-components/native";
import {
  Typography,
  Stack,
  Button,
  TextInput,
  Spacer,
  Divider,
  useToast,
} from "digiwash-components";
import { color } from "@sloth-system/styled-utils";
import useEditProfile from "../../hooks/useEditProfile";
import useNavigation from "../../hooks/useNavigation";
import { Profile } from "../../types/server";

let UserInfoInput = styled(TextInput)`
  background-color: ${color("neutrals.200")};
  border: 0;
  border-radius: 16px;
`;

interface PropTypes {
  data: Profile;
}

function EditProfile(props: PropTypes) {
  let { loading, editProfile } = useEditProfile();
  let nav = useNavigation();
  let [editFirstName, setEditFirstName] = useState(props.data?.first_name);
  let [editLastName, setEditLastName] = useState(props.data?.last_name);
  let toast = useToast();

  return (
    <>
      <Stack>
        <Spacer size="m" />
        <Typography fs="xm" color="common.black">
          نام
        </Typography>
      </Stack>
      <Divider size="m" />
      <UserInfoInput value={editFirstName} onChangeText={setEditFirstName} />
      <Divider size="xxl" />
      <Stack>
        <Spacer size="m" />
        <Typography fs="xm" color="common.black">
          نام خانوادگی
        </Typography>
      </Stack>
      <Divider size="m" />
      <UserInfoInput value={editLastName} onChangeText={setEditLastName} />
      {/* <Divider size="xxl" />
      <Stack>
        <Spacer size="m" />
        <Typography fs="xm" color="common.black">
          شماره موبایل
        </Typography>
      </Stack>
      <Divider size="m" />
      <UserInfoInput disabled={true} value={props.data?.cellphone} /> */}
      <Divider size="xxxl" />
      <Button
        outline
        size="m"
        onPress={() => {
          editProfile({
            first_name: editFirstName,
            last_name: editLastName,
          })
            .then(() => {
              nav.navigate("Profile");
              toast.show("پروفایل با موفقیت به روز شد.", {
                data: { type: "success" },
              });
            })
            .catch((error) => {
              toast.show(error, {
                data: { type: "danger" },
              });
            });
        }}
        disabled={loading || !editFirstName || !editLastName}
      >
        ذخیره تغییرات
      </Button>
    </>
  );
}

export default EditProfile;
